import { ReactNode, forwardRef } from "react";

import { Paper } from "@mui/material";

import { menuDrawerStyles } from "../menuDrawer.styles";

interface MainMenuProps {
  drawerMaxWidth: number;
  isMobile: boolean;
  menuListItems: ReactNode;
  subMenuOpen: boolean;
  onTransitionEnd: VoidFunction;
}

const MainMenu = forwardRef<HTMLDivElement, MainMenuProps>(
  (
    { drawerMaxWidth, isMobile, onTransitionEnd, menuListItems, subMenuOpen },
    ref
  ) => {
    return (
      <Paper
        data-testid="main-menu-drawer"
        ref={ref}
        square
        onTransitionEnd={onTransitionEnd}
        css={[
          menuDrawerStyles.drawer({ drawerMaxWidth }),
          menuDrawerStyles.transition,
          isMobile && subMenuOpen && menuDrawerStyles.hide,
        ]}
      >
        {menuListItems}
      </Paper>
    );
  }
);
MainMenu.displayName = "MainMenu";

export default MainMenu;
